"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=documentVersion.dto.js.map